module.exports = __webpack_public_path__ + "img/project_quiz.67bd6be8.png";